/* Local record ids.
   =================

   Used for records created in PERSONAL mode, where there is no Firestore to
   hand one out. Team records get their ids from Firestore instead.

   Timestamp in base 36 plus four random characters: sortable by creation time,
   short enough to read in a URL, and collision-proof enough for one person's
   own device. These are not secrets and are not meant to be unguessable.
*/

const stamp = () => Date.now().toString(36) + Math.random().toString(36).slice(2, 6);

export const newPlaceId    = () => 'p' + stamp();
export const newClientId   = () => 'c' + stamp();
export const newReferralId = () => 'r' + stamp();
export const newApprovalId = () => 'ap' + stamp();
export const newMHEntryId  = () => 'mh' + stamp();

/* Stops are reordered constantly within one route and never persisted across
   sessions, so they only need to be unique within a page. */
export const newStopId = () => 's' + Math.random().toString(36).slice(2, 9);
